// Trial banner — shown to non-legacy tenants whenever a trial is in
// progress. Legacy (Smeding) and active subscriptions render nothing.
import { useAuth } from '@/context/AuthContext';
import { Link } from 'react-router-dom';
import { Sparkles, AlertTriangle, ExternalLink } from 'lucide-react';

export const TrialBanner = () => {
  const { entitlements, isLegacyTenant, user } = useAuth();
  if (!entitlements || isLegacyTenant) return null;
  if (entitlements.status !== 'trial' && entitlements.status !== 'expired') return null;

  const expired = entitlements.status === 'expired';
  const days = entitlements.days_remaining ?? 0;
  const tone = expired
    ? 'bg-rose-50 dark:bg-rose-950/40 border-rose-300/60 text-rose-800 dark:text-rose-200'
    : days <= 3
      ? 'bg-amber-50 dark:bg-amber-950/40 border-amber-300/60 text-amber-900 dark:text-amber-200'
      : 'bg-sky-50 dark:bg-sky-950/40 border-sky-300/60 text-sky-900 dark:text-sky-200';

  return (
    <div
      className={`border-b px-4 py-2 text-sm flex flex-wrap items-center justify-center gap-3 ${tone}`}
      data-testid="trial-banner"
    >
      {expired
        ? <AlertTriangle className="h-4 w-4 shrink-0" />
        : <Sparkles className="h-4 w-4 shrink-0" />}
      <span data-testid="trial-banner-text">
        {expired
          ? <>Your trial for <strong>{user?.company}</strong> has ended. Some features are now locked.</>
          : <>You're on a free trial — <strong>{days} day{days === 1 ? '' : 's'} remaining</strong>. Teams are read-only · 1 project · 3 checklists · 1 export/week · archive locked.</>}
      </span>
      <a
        href="mailto:info@kaizenkanri.nl?subject=Kanriva™ subscription enquiry"
        className="underline inline-flex items-center gap-1 hover:opacity-80"
        data-testid="trial-banner-cta"
      >
        Discuss subscription <ExternalLink className="h-3 w-3" />
      </a>
    </div>
  );
};

export default TrialBanner;
